import { Stack } from "@mui/material";
import { DividerVertical } from "components/Divider";
import { ExecutionStatusChip } from "features/shared/components/ExecutionStatusChip";
import { ExecutionStatusIcon } from "features/shared/components/ExecutionStatusIcon";

import type { ExecutionStep } from "../../model/types";

type ExecutionStepItemProps = {
  isLast: boolean;
  order: number;
  step: ExecutionStep;
};

export const ExecutionStepItem = ({ isLast, order, step }: ExecutionStepItemProps) => {
  return (
    <Stack className="items-start gap-4">
      <Stack className="relative flex-col self-stretch">
        <ExecutionStatusIcon status={step.status} />
        {!isLast && <DividerVertical className="my-1 h-6" />}
      </Stack>
      <div className="mt-1 flex-1">
        <Stack className="gap-2">
          <h4 className="font-ds-body-semibold-md">
            {order}. {step.name}
          </h4>
          <ExecutionStatusChip status={step.status} />
          {step.message ? (
            <p className="text-lds-foreground-secondary font-ds-body-regular-xs">{step.message}</p>
          ) : null}
        </Stack>
      </div>
    </Stack>
  );
};
